import React from 'react';
import { NextPage, NextPageContext } from 'next';
import { Page } from 'shared-types/Common';

import Markdown from '@common/components/Markdown';
import SectionContainer from '@common/components/SectionContainer';

import * as entityActions from '@store/entity/actions';
import { NormalizedStore } from '@store/entity/entity.types';
import { entitySelectors } from '@store/entity/selectors';

type TermsAndConditionsProps = {
  page: Page;
};

type TermsAndConditionsInitialProps = {
  store: NormalizedStore;
  language: string;
} & NextPageContext;

const TermsAndConditions: NextPage<TermsAndConditionsProps> = ({ page }) => {
  return (
    <SectionContainer>
      <h2>{page.title}</h2>
      <Markdown text={page.content} />
    </SectionContainer>
  );
};

TermsAndConditions.getInitialProps = async ({
  property,
  language,
  store,
  res,
}: TermsAndConditionsInitialProps): Promise<TermsAndConditionsProps> => {
  await entityActions.fetchTermsAndConditionsPage(property.id, language)(store.dispatch);
  const page = entitySelectors.getPage(store.getState(), 'terms-and-conditions');

  if (!page) {
    res?.writeHead(302, {
      Location: '/',
    });
    res?.end();
  }

  return {
    page,
  };
};

export default TermsAndConditions;
